import React, { useEffect, useState } from "react";
import SearchBar from "../../../components/admin/usable/SearchBar";
import AddButton from "../../../components/admin/usable/AddButton";
import Pagination from "@mui/material/Pagination";
import {
  deleteHotel,
  deleteHotelbooking,
  getHotelList,
  hotelBooking,
} from "../../../api/admin/hotel";
import TableLoader from "../../../components/admin/usable/TableLoader";
import { Switch } from "@mui/joy";
import EditButton from "../../../components/admin/usable/actions/EditButton";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
import ViewButton from "../../../components/admin/usable/actions/ViewButton";
import { useNavigate } from "react-router";
import HotelOrderDetails from "./HotelOrderDetails";
import PayNowButton from "../../../components/admin/usable/actions/PayNowButton";
import MakeAPayment from "./components/MakeAPayment";

const HotelOrders = () => {
  const navigate = useNavigate();
  const [HotelData, setHotelData] = useState([]);
  const [FilteredData, setFilteredData] = useState([]);
  const [Search, setSearch] = useState("");
  const [Page, setPage] = useState(1);
  const [Limit, setLimit] = useState(10);
  const [PageData, setPageData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    hotelBooking(setHotelData, Page, Limit, setPageData, setIsLoading);
  }, [Page, Limit]);

  useEffect(() => {
    if (Search.trim() === "") {
      setFilteredData(HotelData);
    } else {
      const result = HotelData.filter((item) =>
        item.invoiceId.toLowerCase().includes(Search.toLowerCase()),
      );
      setFilteredData(result);
    }
  }, [Search, HotelData]);
  const handleDelete = (item) => {
    const id = item.id;
    deleteHotelbooking(
      setHotelData,
      Page,
      Limit,
      setPageData,
      setIsLoading,
      id,
    );
  };

  // Amounts now come straight from the order (db_orders), which already holds
  // the correct full-stay totals. No need to recompute from stayovers/rooms.
  const grandTotal = FilteredData.reduce(
    (sum, item) =>
      sum +
      (Number(item.discountedAmount) || 0) +
      (Number(item.taxAmount) || 0),
    0,
  );
  return (
    <div className="space-y-5">
      <div className="flex justify-between items-center">
        <SearchBar
          onChange={(e) => setSearch(e.target.value)}
          text="Search by Invoice Id"
        />
        <div>
          <AddButton
            text={"Add Offiline Booking"}
            onClick={() => navigate("/admin/order/add")}
          />
        </div>
      </div>
      <div className="w-full overflow-x-auto">
        <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                ID
              </th>

              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Tranx ID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Hotel Logo
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Hotel Name
              </th>

              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Total Amount
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Discounted Amount
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Service Charge
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Paid Amount
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Due
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Payment Status
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Payment Nature
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                CreatedAt
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {isLoading ? (
              <TableLoader colSpan={16} />
            ) : (
              <>
                {FilteredData.length > 0 ? (
                  <>
                    {FilteredData.map((item, index) => {
                      // All amounts from the order record (full-stay totals).
                      const totalAmount = Number(item.totalAmount) || 0;
                      const discountedAmount =
                        Number(item.discountedAmount) || 0;
                      const serviceCharge = Number(item.taxAmount) || 0;
                      const paidAmount = Number(item.paidAmount) || 0;
                      // grand total payable = discounted + service charge
                      const payable = discountedAmount + serviceCharge;
                      const due = payable - paidAmount;
                      return (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {index + 1}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.invoiceId}
                          </td>

                          <td className="px-4 py-3 text-sm text-gray-700">
                            <div className="w-full h-8 overflow-hidden rounded-lg">
                              <img
                                className="w-full h-full object-contain"
                                src={item.hotel?.hotelLogo}
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.hotel?.hotelName}
                          </td>

                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {totalAmount.toFixed(0)} BDT
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {discountedAmount.toFixed(0)} BDT
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {serviceCharge.toFixed(0)} BDT
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {paidAmount.toFixed(0)} BDT
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            <span
                              className={`${
                                due > 0 ? "text-red-600" : "text-green-600"
                              } font-medium`}
                            >
                              {due > 0 ? due.toFixed(0) : 0} BDT
                            </span>
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            <span
                              className={`px-2 py-1 ${
                                item.paymentStatus === "Paid"
                                  ? "bg-green-100 text-green-700"
                                  : "bg-orange-100 text-orange-700"
                              } rounded text-xs`}
                            >
                              {item.paymentStatus === "Paid"
                                ? "Paid"
                                : "Unpaid"}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            <span
                              className={`px-2 py-1 ${
                                item.paymentNature === "Online"
                                  ? "bg-orange-100 text-orange-700"
                                  : "bg-green-100 text-green-700"
                              } rounded text-xs`}
                            >
                              {item.paymentNature === "Online"
                                ? "Online"
                                : "Offline"}
                            </span>
                          </td>

                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.createdAt.slice(0, 10)}
                          </td>
                          <td className="px-4 py-3 text-sm">
                            <div className="flex gap-x-2">
                              <MakeAPayment
                                item={item}
                                setHotelData={setHotelData}
                                Page={Page}
                                Limit={Limit}
                                setPageData={setPageData}
                                setIsLoading={setIsLoading}
                              />
                              <ViewButton
                                onClick={() =>
                                  navigate(
                                    `/admin/order/hotel/details/${item.id}`,
                                  )
                                }
                              />
                              <DeleteButton
                                onClick={() => handleDelete(item)}
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <tr>
                    <td
                      colSpan={15}
                      className="text-center py-5 text-gray-500 font-semibold"
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center">
        <p className="text-xs">
          Showing {(Page - 1) * Limit + 1} to{" "}
          {(Page - 1) * Limit + HotelData.length} of {PageData} entries
        </p>
        <Pagination
          count={PageData || 1}
          page={Page}
          onChange={(event, value) => setPage(value)}
        />
      </div>
    </div>
  );
};

export default HotelOrders;
